import { render, staticRenderFns } from "./PageController.vue?vue&type=template&id=8218d94e&"
import script from "./PageController.vue?vue&type=script&lang=js&"
export * from "./PageController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports